import React from "react";
import Media from "react-media";
import { LoginDesktop } from "./desktop/LoginDesktop";
import { LoginMobile } from "./mobile/LoginMobile";

export class LoginPage extends React.Component<any,any> {

    render(){
        return <div>
            {
               [<Media query="(max-width: 1064px)" render={() => {
                   return <LoginMobile {...this.props} />
               }}/>, <Media query="(min-width: 1065px)" render={() => {
                return <LoginDesktop {...this.props} />
               }}/>]
            }
        </div>
    }
}